import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const Row = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

Row.displayName = 'Row'

export default Row
